const SEAL_LOADER_DURATION = 1800;
const SEAL_LOADER_VIEWBOX_SIZE = 750;
const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';

const SEAL_LOADER_GUIDE = [
  'M 126 146',
  'C 110 140 96 160 96 145',
  'C 96 118 150 82 218 76',
  'C 274 74 301 45 354 48',
  'C 402 51 407 143 407 246',
  'C 407 316 410 347 456 372',
  'C 521 406 622 420 683 474',
  'C 736 521 740 600 704 650',
  'C 673 693 621 706 565 697',
  'C 511 688 459 698 402 700',
  'C 330 703 258 700 190 684',
  'C 116 667 68 633 48 580',
  'C 24 516 48 446 88 386',
  'C 122 335 165 277 174 224',
  'C 179 190 158 158 126 146',
].join(' ');

const sealLoaderMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const sealLoaders = new Set();
let sealLoaderGuide;
let sealLoaderGuideLength = 0;
let sealLoaderFrame = 0;
let sealLoaderElapsed = 0;
let sealLoaderLastFrame = 0;

function ensureSealLoaderGuide() {
  if (sealLoaderGuide) return;

  const svg = document.createElementNS(SVG_NAMESPACE, 'svg');
  svg.setAttribute('aria-hidden', 'true');
  svg.setAttribute('viewBox', `0 0 ${SEAL_LOADER_VIEWBOX_SIZE} ${SEAL_LOADER_VIEWBOX_SIZE}`);
  svg.style.cssText = 'position:fixed;width:0;height:0;overflow:hidden;visibility:hidden;pointer-events:none';

  sealLoaderGuide = document.createElementNS(SVG_NAMESPACE, 'path');
  sealLoaderGuide.setAttribute('d', SEAL_LOADER_GUIDE);
  svg.append(sealLoaderGuide);
  (document.body || document.documentElement).append(svg);
  sealLoaderGuideLength = sealLoaderGuide.getTotalLength();
}

function canRunSealLoaders() {
  return sealLoaders.size > 0 && !document.hidden && !sealLoaderMotion.matches;
}

function stopSealLoaderFrame() {
  if (sealLoaderFrame) cancelAnimationFrame(sealLoaderFrame);
  sealLoaderFrame = 0;
  sealLoaderLastFrame = 0;
}

function renderSealLoaders(now) {
  sealLoaderFrame = 0;
  if (!canRunSealLoaders()) return;

  if (!sealLoaderLastFrame) sealLoaderLastFrame = now;
  sealLoaderElapsed = (sealLoaderElapsed + now - sealLoaderLastFrame) % SEAL_LOADER_DURATION;
  sealLoaderLastFrame = now;

  const point = sealLoaderGuide.getPointAtLength((sealLoaderElapsed / SEAL_LOADER_DURATION) * sealLoaderGuideLength);
  const x = `${(point.x / SEAL_LOADER_VIEWBOX_SIZE) * 100}%`;
  const y = `${(point.y / SEAL_LOADER_VIEWBOX_SIZE) * 100}%`;

  for (const loader of sealLoaders) {
    loader.style.setProperty('--seal-loader-spot-x', x);
    loader.style.setProperty('--seal-loader-spot-y', y);
    loader.setAttribute('data-seal-loader-ready', '');
  }

  sealLoaderFrame = requestAnimationFrame(renderSealLoaders);
}

function startSealLoaderFrame({ reset = false } = {}) {
  if (!canRunSealLoaders() || sealLoaderFrame) return;
  ensureSealLoaderGuide();
  if (reset) sealLoaderElapsed = 0;
  sealLoaderLastFrame = performance.now();
  sealLoaderFrame = requestAnimationFrame(renderSealLoaders);
}

function registerSealLoader(loader) {
  const wasEmpty = sealLoaders.size === 0;
  sealLoaders.add(loader);
  if (wasEmpty) sealLoaderElapsed = 0;

  if (sealLoaderMotion.matches) {
    loader.removeAttribute('data-seal-loader-ready');
    return;
  }

  startSealLoaderFrame({ reset: wasEmpty });
}

function unregisterSealLoader(loader) {
  sealLoaders.delete(loader);
  if (sealLoaders.size === 0) stopSealLoaderFrame();
}

function handleSealLoaderVisibility() {
  if (document.hidden) {
    stopSealLoaderFrame();
  } else {
    startSealLoaderFrame();
  }
}

function handleSealLoaderMotionPreference() {
  if (sealLoaderMotion.matches) {
    stopSealLoaderFrame();
    for (const loader of sealLoaders) loader.removeAttribute('data-seal-loader-ready');
  } else {
    startSealLoaderFrame({ reset: true });
  }
}

class SealLoader extends HTMLElement {
  connectedCallback() {
    registerSealLoader(this);
  }

  disconnectedCallback() {
    unregisterSealLoader(this);
  }
}

document.addEventListener('visibilitychange', handleSealLoaderVisibility);
if (typeof sealLoaderMotion.addEventListener === 'function') {
  sealLoaderMotion.addEventListener('change', handleSealLoaderMotionPreference);
} else {
  sealLoaderMotion.addListener(handleSealLoaderMotionPreference);
}

if (!customElements.get('seal-loader')) customElements.define('seal-loader', SealLoader);
